import * as React from "react";
import OutlinedInput from "@mui/material/OutlinedInput";
import InputLabel from "@mui/material/InputLabel";
import MenuItem from "@mui/material/MenuItem";
import FormControl from "@mui/material/FormControl";
import ListItemText from "@mui/material/ListItemText";
import Select from "@mui/material/Select";
import Checkbox from "@mui/material/Checkbox";
import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import { Grid2 } from "@mui/material";
import axios from "axios";
import { XMLParser } from "fast-xml-parser";
import * as XLSX from "xlsx";

const ITEM_HEIGHT = 48;
const ITEM_PADDING_TOP = 8;
const MenuProps = {
	PaperProps: {
		style: {
			maxHeight: ITEM_HEIGHT * 4.5 + ITEM_PADDING_TOP,
			width: 250
		}
	}
};

let envs = ["Live", "Staging"];
let regions = ["ne", "cat", "phx"];
let series = [];
console.log("222222");
function BenchmarkAndLeadsProcessing(mode) {
	console.log("1111111111111 " + mode);
	const [focusFileType, setFocusFileType] = React.useState("");
	const [focusBenchMark, setFocusBenchMark] = React.useState("");
	const [focusDate, setFocusDate] = React.useState("");
	const [selectedFile, setSelectedFile] = React.useState(null);
	const [uploading, setUploading] = React.useState(false);
	const [uploadMessage, setUploadMessage] = React.useState("");
	const dateInputRef = React.useRef(null);

	React.useEffect(() => {
		if (uploadMessage === "File uploaded successfully.") {
			console.log("File uploaded successfully, opening file");
		}
	}, [uploadMessage]);

	const openDatePicker = () => {
		if (dateInputRef.current?.showPicker) {
			dateInputRef.current.showPicker();
		} else {
			dateInputRef.current?.focus();
		}
	};

	const handleFileTypeChange = (event) => {
		const nextFileType = event.target.value;

		setFocusFileType(nextFileType);
		setFocusBenchMark("");
		setFocusDate("");
		setSelectedFile(null);
		setUploadMessage("");
	};

	const uploadFileToServer = async (file) => {
		if (!file) {
			setUploadMessage("Please choose a file before uploading.");
			return null;
		}

		const formData = new FormData();
		formData.append("file", file);
		formData.append("fileType", focusFileType);
		formData.append("benchmark", focusBenchMark);
		formData.append("date", focusDate);

		setUploading(true);
		setUploadMessage("");

		try {
			const response = await axios.post(
				process.env.REACT_APP_BENCHMARK_UPLOAD_URL || "/api/upload",
				formData,
				{
					headers: {
						"Content-Type": "multipart/form-data"
					}
				}
			);

			setUploadMessage("File uploaded successfully.");
			return response.data;
		} catch (error) {
			console.error("Upload failed", error);
			setUploadMessage(error.response?.data?.message || "File upload failed.");
			return null;
		} finally {
			setUploading(false);
		}
	};

	const processLeadListFile = (file) => {
		const reader = new FileReader();
		reader.onload = async (e) => {
			try {
				const data = new Uint8Array(e.target.result);
				const EXCLUDE_COLUMNS = new Set([
					"Sales Person",
					"Customer Last Name",
					"Customer First Name",
					"Customer Address Street One",
					"Customer Address Street Two",
					"Customer Address City",
					"Customer Address Region Code",
					"Customer Address Postal Code",
					"Customer Phone",
					"Customer Email",
					"Customer Comments"
				]);

				const wb = XLSX.read(data, { type: "array" });
				const ws = wb.Sheets[wb.SheetNames[0]];
				const fullRange = XLSX.utils.decode_range(ws["!ref"]);
				const headerRow = 9;

				// Read headers and find which columns to keep
				const keepCols = [];
				for (let c = fullRange.s.c; c <= fullRange.e.c; c++) {
					const cell = ws[XLSX.utils.encode_cell({ r: headerRow, c })];
					const header = cell ? String(cell.v ?? "").trim() : "";
					if (!EXCLUDE_COLUMNS.has(header)) keepCols.push(c);
				}

				const escapeCell = (val) => {
					const s = val != null ? String(val) : "";
					return s.includes(",") || s.includes('"') || s.includes("\n")
						? `"${s.replace(/"/g, '""')}"`
						: s;
				};

				// Build the header CSV row
				const headerCsvRow = keepCols.map(c => {
					const cell = ws[XLSX.utils.encode_cell({ r: headerRow, c })];
					return escapeCell(cell?.v ?? "");
				}).join(",");

				// Group data rows by date extracted from first kept column
				const dateGroups = {};
				for (let r = headerRow + 1; r <= fullRange.e.r; r++) {
					const firstCell = ws[XLSX.utils.encode_cell({ r, c: keepCols[0] })];
					const firstVal = firstCell != null ? String(firstCell.w ?? firstCell.v ?? "") : "";
					// Extract just the date portion (before any space/time component)
					const datePart = firstVal.split(" ")[0] || "unknown";

					const rowCsv = keepCols.map(c => {
						const cell = ws[XLSX.utils.encode_cell({ r, c })];
						return escapeCell(cell?.w ?? cell?.v ?? "");
					}).join(",");

					if (!dateGroups[datePart]) dateGroups[datePart] = [];
					dateGroups[datePart].push(rowCsv);
				}

				const dates = Object.keys(dateGroups);
				if (dates.length === 0) {
					setUploadMessage("No data rows found.");
					return;
				}

				// Upload one CSV per unique date to GCS via the Express server
				setUploadMessage(`Uploading ${dates.length} file(s) to GCS…`);
				const uploads = dates.map(async (date) => {
					const csvContent = [headerCsvRow, ...dateGroups[date]].join("\n");
					const dateStr = date.replace(/\//g, "-");
					const random5 = Math.floor(10000 + Math.random() * 90000);
					const filename = `lead_list_${dateStr}_${random5}.csv`;
					await axios.post("/api/upload-csv", { filename, content: csvContent });
					return filename;
				});

				const filenames = await Promise.all(uploads);
				setUploadMessage(`${filenames.length} file(s) uploaded to GCS: ${filenames.join(", ")}`);
			} catch (err) {
				console.error("Lead list processing failed", err);
				setUploadMessage("Failed to process file. Make sure it is a valid .xlsx file.");
			}
		};
		reader.readAsArrayBuffer(file);
	};

	const handleFileUpload = async (event) => {
		const file = event.target.files?.[0];
		setSelectedFile(file || null);

		if (file) {
			if (focusFileType === "Lead List") {
				processLeadListFile(file);
			} else {
				await uploadFileToServer(file);
			}
		}

		event.target.value = "";
	};

	return (
		<div id="htmlPage">
			<h1>Benchmark and Leads Processing</h1>
			<Grid2 container spacing={2} direction="column">
				<FormControl sx={{ m: 1, width: 300 }}>
					<InputLabel id="region-select-label">File Type</InputLabel>
					<Select
						labelId="file-type-select-label"
						id="file-type-select"
						value={focusFileType}
						onChange={handleFileTypeChange}
						input={<OutlinedInput label="File Type" />}
						MenuProps={MenuProps}
					>
						<MenuItem key="fileTypeBenchmark" value="Benchmark">
							<ListItemText primary="Benchmark" />
						</MenuItem>
						<MenuItem key="fileTypeLeadList" value="Lead List">
							<ListItemText primary="Lead List" />
						</MenuItem>
					</Select>
				</FormControl>

				{focusFileType === "Benchmark" ? (
					<>
						<FormControl sx={{ m: 1, width: 300 }}>
							<InputLabel id="benchmark-select-label">Benchmark</InputLabel>
							<Select
								labelId="benchmark-select-label"
								id="benchmark-select"
								value={focusBenchMark}
								onChange={(e) => setFocusBenchMark(e.target.value)}
								input={<OutlinedInput label="Benchmark" />}
								MenuProps={MenuProps}
							>
								<MenuItem key="batBenchmark" value="BAT">
									<ListItemText primary="BAT" />
								</MenuItem>
								<MenuItem key="tcomBenchmark" value="TCOM">
									<ListItemText primary="TCOM" />
								</MenuItem>
								<MenuItem key="fbBenchmark" value="FB">
									<ListItemText primary="FB" />
								</MenuItem>
								<MenuItem key="rctBenchmark" value="RCT">
									<ListItemText primary="RCT" />
								</MenuItem>
								<MenuItem key="setBenchmark" value="SET">
									<ListItemText primary="SET" />
								</MenuItem>
							</Select>
						</FormControl>
						<TextField
							sx={{ m: 1, width: 300 }}
							id="benchmark-date"
							label="Date"
							type="date"
							value={focusDate}
							inputRef={dateInputRef}
							onClick={openDatePicker}
							onChange={(e) => setFocusDate(e.target.value)}
							InputLabelProps={{ shrink: true }}
						/>
					</>
				) : null}

				{focusFileType ? (
					<FormControl sx={{ m: 1, width: 300 }}>
						<input
							id="benchmark-upload-input"
							type="file"
							accept={focusFileType === "Lead List" ? ".xlsx" : undefined}
							onChange={handleFileUpload}
							style={{ display: "none" }}
						/>
						<label htmlFor="benchmark-upload-input">
							<Button variant="contained" component="span" disabled={uploading}>
								{uploading ? "Uploading..." : "Upload File"}
							</Button>
						</label>
						{selectedFile ? <div>{selectedFile.name}</div> : null}
						{uploadMessage ? <div>{uploadMessage}</div> : null}
					</FormControl>
				) : null}
			</Grid2>
			<Grid2 container spacing={2} id="ads"></Grid2>
		</div>
	);
}

export default BenchmarkAndLeadsProcessing;
